<template>
  <div class="footer">
    技术支持：武汉讯网信息技术有限公司
  </div>
</template>
<script>
import { mapState, mapMutations } from "vuex";

export default {
  components: {
  },
  data () {
    return {
      
    };
  },
  mounted () {
  },
  methods: {
   
  },
};
</script>
<style lang="scss" scoped>
.footer {
  width: 1200px;
  background-color: #fff;
  padding: 20px 0;
  font-size: 14px;
  color: #767676;
  text-align: center;
}
</style>
